<div class="photo">
    <span class="photo__title">{{photoTitle}}</span>
    <img *ngIf="photoData != ''" [src]="getImage(photoData)" [matTooltip]="photoDescription" (click)="viewPhoto()" [@fadeIn]/>
    <img *ngIf="newPhoto != null && newPhoto != ''" [src]="newPhoto" />
    <div *ngIf="photoData == '' && (newPhoto == '' || newPhoto == null)" class="upload-photo" (click)="fileInput.click()"><span>Upload Photo</span></div>
  <input style="display: none;" type="file"
         #fileInput
         (change)="onSelectPhoto($event)">
</div>
